import React, { useCallback, useEffect } from "react";
import { Box, makeStyles, CardMedia } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  trackProps,
  useTracker,
  withTrack,
} from "@dpdgroupuk/react-event-tracker";

import Header from "../../components/header";
import LoginButton from "../../components/LoginButton";
import { getCurrentUser } from "../../store/selectors/user";
import { login, setUserData } from "../../store/actions/user";
import loginSplash from "../../assets/png/loginSplash.png";
import QuantumLogoIcon from "../../components/icons/QuantumLogoIcon";
import { LOGIN_PAGE } from "../../constants/analytics";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    display: "flex",
    flexFlow: "column",
  },
  content: {
    display: "flex",
    flex: 1,
    zIndex: 0,
    position: "relative",
  },
  gradient: {
    flexFlow: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    background:
      "linear-gradient(180deg, #A90034 0%, rgba(220, 0, 50, 0.2) 100%)",
    zIndex: 2,
    display: "flex",
  },
  logo: {
    margin: `${typography.pxToRem(50)} 0`,
  },
  splash: {
    zIndex: 1,
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
}));

const LoginPage = () => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const tracker = useTracker();
  const user = useSelector(getCurrentUser);

  const clearErrorMsg = useCallback(
    () => dispatch(setUserData({ error: "" })),
    [dispatch]
  );
  const onLogin = useCallback(() => {
    dispatch(login());
    tracker.logEvent(LOGIN_PAGE.SELECT_SIGN_IN_WITH_GOOGLE);
  }, [tracker, dispatch]);

  useEffect(() => {
    return () => {
      tracker.setInterfaceId(null);
    };
  }, [tracker]);

  return (
    <Box width={1} className={styles.container}>
      <Header />
      <Box className={styles.content}>
        <Box className={styles.gradient}>
          <Box className={styles.logo}>
            <QuantumLogoIcon />
          </Box>
          <LoginButton
            error={user.error}
            onLogin={onLogin}
            onCloseError={clearErrorMsg}
          />
        </Box>
        <CardMedia className={styles.splash} image={loginSplash} />
      </Box>
    </Box>
  );
};

export default withTrack(trackProps(LOGIN_PAGE))(LoginPage);
